import Splide from "@splidejs/splide";

class LyleShopTheLook extends HTMLElement {
  #images = null;
  #products = null;

  connectedCallback() {
    const images = this.querySelector("[data-shop-the-look-images]");
    const products = this.querySelector("[data-shop-the-look-products]");
    const slides = products?.querySelectorAll(".splide__slide").length || 0;

    if (!images || !products || slides <= 1) {
      this.classList.add("is-ready");
      return;
    }

    this.#products = new Splide(products, {
      arrows: false,
      drag: false,
      pagination: false,
      rewind: true,
      type: "fade",
    });
    this.#images = new Splide(images, {
      arrows: false,
      pagination: false,
      rewind: true,
    });

    this.#products.sync(this.#images);
    this.#products.mount();
    this.#images.mount();
    this.classList.add("is-ready");

    this.querySelector("[data-shop-the-look-previous]")?.addEventListener(
      "click",
      this.#previous,
    );
    this.querySelector("[data-shop-the-look-next]")?.addEventListener(
      "click",
      this.#next,
    );
  }

  disconnectedCallback() {
    this.querySelector("[data-shop-the-look-previous]")?.removeEventListener(
      "click",
      this.#previous,
    );
    this.querySelector("[data-shop-the-look-next]")?.removeEventListener(
      "click",
      this.#next,
    );
    this.#products?.destroy();
    this.#images?.destroy();
    this.#products = null;
    this.#images = null;
  }

  #previous = () => this.#products?.go("<");

  #next = () => this.#products?.go(">");
}

if (!customElements.get("lyle-shop-the-look")) {
  customElements.define("lyle-shop-the-look", LyleShopTheLook);
}
